import { TimeValidationError } from '@mui/x-date-pickers';

const TimePickerErrorMessages = (reason: TimeValidationError) => {
    switch (reason) {
        case 'invalidDate':
            return 'Invalid Date Time';
        case 'minTime':
            return 'Error - Min Time';
        case 'maxTime':
            return 'Error - Max Time';
        default:
            return '';
    }
};

export default TimePickerErrorMessages;
